import z from 'zod'

export type Company = {
  name: string
  id: string
  parentId?: string
  logoUrl?: string
}

export const createCompanyRequestSchema = z.object({
  name: z.string().nonempty(),
  logoUrl: z.string().optional(),
  parentId: z.string().optional(),
})

export type CreateCompanyRequest = z.infer<typeof createCompanyRequestSchema>

export const updateCompanyRequestSchema = createCompanyRequestSchema.extend({
  id: z.string().nonempty(),
})

export type UpdateCompanyRequest = z.infer<typeof updateCompanyRequestSchema>

export const addUserCompanyRequestSchema = z.object({
  id: z.string().nonempty(),
  userId: z.string().uuid().nonempty(),
})

export const deleteCompanyRequestSchema = z.object({
  id: z.string().nonempty().uuid(),
})

export type DeleteCompanyRequest = z.infer<typeof deleteCompanyRequestSchema>

export type AddUserCompanyRequest = z.infer<typeof addUserCompanyRequestSchema>

export const removeUserCompanyRequestSchema = addUserCompanyRequestSchema

export type RemoveUserCompanyRequest = z.infer<typeof removeUserCompanyRequestSchema>
